import { CircleCheck, CircleX } from "lucide-react";

export const ProcessStatusIcon = ({ isSuccess, isDryRun }: { isSuccess: boolean; isDryRun: boolean }) => (
  isSuccess
    ? <CircleCheck className={isDryRun ? "text-muted process-log-icon-dry-run" : "text-success"} size={20} />
    : <CircleX className={isDryRun ? "text-muted process-log-icon-dry-run" : "text-danger"} size={20} />
);
